import { useState, useEffect } from "react";
import LiquidGlass from "./LiquidGlass";

const SHOW_AFTER_PX = 350;

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let rafId = 0;

    const update = () => {
      rafId = 0;
      setVisible(window.scrollY > SHOW_AFTER_PX);
    };

    const onScroll = () => {
      if (rafId) return;
      rafId = window.requestAnimationFrame(update);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    update();

    return () => {
      window.removeEventListener("scroll", onScroll);
      if (rafId) window.cancelAnimationFrame(rafId);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <LiquidGlass
      as="button"
      type="button"
      onClick={scrollToTop}
      tone="dark"
      cornerRadius={999}
      bezelWidth={10}
      thickness={46}
      blur={6}
      shadowOffsetY={3}
      shadowBlur={10}
      tint={{ r: 1, g: 1, b: 1, a: 0.24 }}
      specularOpacity={0.92}
      specularStrength={1.5}
      className={`back-to-top ${visible ? "back-to-top-visible" : ""}`}
      aria-label="Scroll back to top"
      tabIndex={visible ? 0 : -1}
    >
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path className="back-to-top-arrow-outline" d="M12 19V5M5 12l7-7 7 7" />
        <path className="back-to-top-arrow-core" d="M12 19V5M5 12l7-7 7 7" />
      </svg>
    </LiquidGlass>
  );
}
